<template>
  <div class="maintance-wrap" style="display: flex;">
    <div class="maintance-tree">
      <div class="tree1" id="chart1"></div>
      <div class="tree2" id="chart2"></div>
    </div>
    <div style="margin-left:20px; margin-right:20px; width: 56%">
      <div>
        <!-- <m-map ref="mMap" class="mmap-wrap" :lngLat="lngLat" :markers="markers"></m-map> -->
        <div class="mmap-wrap" id="map_1"></div>
      </div>
      <div style="margin-top: 20px;display:flex;" class="warnTable">
        <div
          style="width:100%;height:120px;text-align:center;margin:auto"
          class="warnTabless"
        >
          <div class="chargeType">累计充电量{{ rechargeQuantity }}</div>
          <div class="chargeType">累计放电量{{ dischargeQuantity }}</div>
        </div>
      </div>
    </div>
    <div style="margin-right: 10px; width: 340px">
      <div style="height: 350px" class="warnInfo-wrap">
        <el-card class="box-card">
          <div slot="header" class="clearfix" style="display: flex">
            <span style="width:80px;font-size:18px;font-weight:bold"
              >装机电量</span
            >
          </div>
          <!-- <div style="overflow-y: auto; height: 340px" class="real-wrap"> -->
          <div class="warnInfo-wrap-box">
            <vue-seamless-scroll
              :data="powerList"
              class="seamless-warp2"
              :class-option="optionSetting"
            >
              <div
                v-for="(item, index) in powerList"
                :key="index"
                class="text item"
              >
                <div style="display: flex">
                  <div style="width: 10%">{{ index + 1 }}</div>
                  <div style="width: 55%">{{ item.modelName }}</div>
                  <div style="width: 35%; text-align: right">
                    {{ item.electricity }}度
                  </div>
                </div>
              </div>
            </vue-seamless-scroll>
          </div>
        </el-card>
      </div>
      <div style="height: 350px;margin-top: 10px;">
        <el-card class="box-card">
          <div slot="header" class="clearfix" style="display:flex;">
            <span style="width:80px;font-size:18px;font-weight:bold"
              >告警信息</span
            >
          </div>
          <div class="warnInfo-wrap-box">
            <vue-seamless-scroll
              :data="warnData"
              class="seamless-warp"
              :class-option="optionSetting2"
            >
              <div
                v-for="(item, index) in warnData"
                :key="'a' + index"
                class="text item"
              >
                <div style="display: flex">
                  <!-- 设备名称  告警信息  时间 -->
                  <div style="width: 10%">{{ index + 1 }}</div>
                  <div style="width: 40%">{{ item.device }}</div>
                  <div style="width: 50%; text-align: right">
                    {{ item.noticeTime }}
                  </div>
                </div>
                <div style="padding-left: 10%; margin-top: 10px">
                  {{ item.reason }}
                </div>
              </div>
            </vue-seamless-scroll>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import MMap from "./MMap";
export default {
  name: "deviceManagement",
  components: { MMap },
  data() {
    return {
      projectDeviceData: [],
      listData: [],
      tableHeight: "130",
      markers: [],
      animateUp: false,
      warnInfoTimeout: -1,
      warnData: [], //告警信息
      powerList: [], //装机电量
      xAxis: [],
      yAxis1: [],
      yAxis2: [],
      normalCount: 0,
      offlineCount: 0,
      mapList: [], //地图
      rechargeQuantity: "",
      dischargeQuantity: ""
    };
  },
  computed: {
    optionSetting() {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: this.powerList.length, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      };
    },
    optionSetting2() {
      return {
        step: 0.15, // 数值越大速度滚动越快
        limitMoveNum: this.warnData.length, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      };
    }
  },
  watch: {},
  methods: {
    // 左上 柱状图
    chart1() {
      var myChart = this.$echarts.init(document.getElementById("chart1"));
      let option = {};
      option = {
        title: {
          text: "设备分布",
          textStyle: {
            color: "#ffffff"
          },
          top: "10px",
          left: "15px"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        legend: {
          data: ["设备数量", "项目数量"],
          textStyle: {
            color: "#ffffff"
          }
        },
        color: ["#5CEBB8", "#0BC6D1"],
        xAxis: [
          {
            type: "category",
            axisTick: { show: false },
            data: this.xAxis,
            axisLabel: {
              //修改坐标系字体颜色
              show: true,
              textStyle: {
                color: "#ffffff",
                fontSize: "10px"
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              //修改坐标系字体颜色
              show: true,
              textStyle: {
                color: "#ffffff",
                fontSize: "10px"
              }
            }
          }
        ],
        series: [
          {
            // name: '设备数量',
            type: "bar",
            barGap: 0,
            emphasis: {
              focus: "series"
            },
            data: this.yAxis1
          },
          {
            // name: '项目数量',
            type: "bar",
            emphasis: {
              focus: "series"
            },
            data: this.yAxis2
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    // 左下 圆饼图
    chart2() {
      var myChart = this.$echarts.init(document.getElementById("chart2"));
      let option = {};
      option = {
        title: {
          text: "设备概况",
          textStyle: {
            color: "#ffffff"
          },
          top: "10px",
          left: "15px"
        },
        tooltip: {
          trigger: "item"
        },
        legend: {
          bottom: "5%",
          textStyle: {
            color: "#ffffff"
          }
        },
        series: [
          {
            // name: '访问来源',
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2
            },
            label: {
              show: false,
              position: "center"
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "20",
                fontWeight: "bold"
              }
            },
            labelLine: {
              show: false
            },
            data: [
              {
                value: this.normalCount,
                name: "在线数量",
                label: { color: "#D4BD0A" }
              },
              {
                value: this.offlineCount,
                name: "离线数量",
                label: { color: "#21A5AF" }
              }
            ],
            color: ["#D4BD0A", "#21A5AF"] //DE5A50  FFD30D  0BC6D1 D4BD0A
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    map() {
      // 基于准备好的dom，初始化echarts实例
      var myChart = this.$echarts.init(document.getElementById("map_1"));
      var toolTipData = [];
      var data = [];
      var geoCoordMap = [];
      for (var i = 0; i < this.mapList.length; i++) {
        toolTipData.push({
          name: this.mapList[i].provinceName,
          value: [
            { name: "项目数量", value: this.mapList[i].count },
            { name: "设备数量", value: this.mapList[i].deviceCount }
          ]
        });
        data.push({
          name: this.mapList[i].provinceName,
          value: this.mapList[i].stationCount
        });
        geoCoordMap.push({
          name: this.mapList[i].provinceName,
          value: [
            this.mapList[i].longitude,
            this.mapList[i].latitude,
            this.mapList[i].count
          ]
        });
      }
      var convertData = function(data) {
        var res = [];
        for (var i = 0; i < data.length; i++) {
          for (var j = 0; j < geoCoordMap.length; j++) {
            if (data[i].name == geoCoordMap[j].name) {
              res.push({
                name: data[i].name,
                value: geoCoordMap[j].value
              });
            }
          }
        }
        return res;
      };
      let option = {};
      option = {
        title: {
          text: "KOPA金邦云平台",
          textStyle: {
            color: "#ffffff"
          },
          top: "10px",
          left: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: function(params) {
            if (typeof params.value[2] == "undefined") {
              var toolTiphtml = "";

              for (var i = 0; i < toolTipData.length; i++) {
                if (params.name == toolTipData[i].name) {
                  toolTiphtml += toolTipData[i].name + ":<br>";

                  for (var j = 0; j < toolTipData[i].value.length; j++) {
                    toolTiphtml +=
                      toolTipData[i].value[j].name +
                      ":" +
                      toolTipData[i].value[j].value +
                      "<br>";
                  }
                }
              }

              console.log(toolTiphtml);

              return toolTiphtml;
            } else {
              var toolTiphtml = "";

              for (var i = 0; i < toolTipData.length; i++) {
                if (params.name == toolTipData[i].name) {
                  toolTiphtml += toolTipData[i].name + ":<br>";

                  for (var j = 0; j < toolTipData[i].value.length; j++) {
                    toolTiphtml +=
                      toolTipData[i].value[j].name +
                      ":" +
                      toolTipData[i].value[j].value +
                      "<br>";
                  }
                }
              }

              console.log(toolTiphtml);

              return toolTiphtml;
            }
          }
        },

        geo: {
          map: "china",
          label: {
            emphasis: {
              show: false
            }
          },
          roam: true,
          itemStyle: {
            normal: {
              areaColor: "#4c60ff",
              borderColor: "#002097"
            },
            emphasis: {
              areaColor: "#293fff"
            }
          }
        },
        series: [
          {
            name: "",
            type: "effectScatter",

            showEffectOn: "render",
            rippleEffect: {
              brushType: "stroke"
            },
            coordinateSystem: "geo",
            data: convertData(data),
            symbolSize: function(val) {
              return 10;
            },
            label: {
              normal: {
                formatter: "{b}",
                position: "right",
                show: true
              },
              emphasis: {
                show: true
              }
            },
            itemStyle: {
              normal: {
                color: "#ffeb7b"
              }
            }
          }
        ]
      };

      myChart.setOption(option);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    close() {},
    submit() {}
  },
  mounted() {},
  created() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {
    this.$store.dispatch("form/handle", {
      url: "/battery/dcMonitor/screen",
      // data:{companyId:localStorage.getItem("curcompanyId")},
      method: "get",
      callback: resp => {
        this.xAxis = resp.provinceXAxis;
        this.yAxis1 = resp.deviceYAxis;
        this.yAxis2 = resp.projectYAxis;
        this.chart1();
        this.normalCount = resp.normalCount;
        this.offlineCount = resp.offlineCount;
        this.chart2();
        this.mapList = resp.mapRespList;
        this.map();
        this.rechargeQuantity = resp.rechargeQuantity;
        this.dischargeQuantity = resp.dischargeQuantity;
        if (resp.alarmInfoRespList) {
          this.warnData = resp.alarmInfoRespList;
        }
        if (resp.modelInfoRespList) {
          this.powerList = resp.modelInfoRespList;
        }
      }
    });
  }, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {
    clearInterval(this.warnInfoTimeout);
  }, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped>
.maintance-wrap {
  background: url("../../../../static/image/maintancebg.png");
  // background: linear-gradient(#1955c6, #0b2d8e);
}

.maintance-wrap /deep/ .el-input__inner,
.el-tree,
.el-range-editor .el-range-input {
  background-color: #0d115d;
  color: #fff;
}
.maintance-wrap /deep/ .el-range-editor .el-range-input {
  background-color: #0d115d;
  color: #fff;
}

.maintance-wrap
  /deep/
  .el-table--striped
  .el-table__body
  tr.el-table__row--striped
  td {
  background-color: #0d115d;
  // background: #136cc0;
}

.maintance-wrap /deep/ .STable .table .el-table th.is-leaf {
  background-color: #0d115d;
  color: #ffffff;
  border-bottom: 1px solid #f59728;
  border-right: 1px solid #f59728;
}
.maintance-wrap /deep/ .el-table th {
  background-color: #0d115d;
  color: #ffffff;
  //border: 1px solid #F59728;
}
.maintance-wrap /deep/ .el-table tr {
  background-color: #0d115d;
  color: #ffffff;
  //border: 1px solid #F59728;
}
.maintance-wrap /deep/ .el-table--border {
  border: 1px solid #f59728;
}
.maintance-wrap /deep/ .el-table--group {
  border: 1px solid #f59728;
}
.maintance-wrap /deep/ .el-table--border td {
  border-right: 1px solid #f59728;
}
.maintance-wrap /deep/ .el-table td {
  border-bottom: 1px solid #f59728;
}
.maintance-wrap /deep/ .el-pagination button:disabled {
  background-color: #0d115d;
}
.maintance-wrap /deep/ .el-dialog,
.el-pager li {
  background: #0d115d;
  color: #ffffff;
}

.maintance-wrap /deep/ .el-pagination .btn-next,
.el-pagination .btn-prev {
  background: #0d115d;
}
.maintance-wrap /deep/ .el-card {
  background: #0d115d;
  color: #ffffff;
  background-image: url("../../../../static/image/kuangbg.png");
  background-size: 100% 100%;
  border: none;
}
.maintance-wrap /deep/ .el-pagination__total {
  color: #ffffff;
}
.maintance-wrap /deep/ .el-pagination__jump {
  color: #ffffff;
}
.maintance-wrap /deep/ tbody tr:hover > td {
  background-color: #1a2f83;
}
.maintance-wrap /deep/ .el-button--success.is-plain {
  background: #08074b;
}
.maintance-wrap /deep/ .el-button {
  background: #08074b;
}
.maintance-wrap /deep/ .el-form-item__label,
.el-date-editor .el-range-separator {
  color: #ffffff;
}
.maintance-wrap /deep/ .el-date-editor .el-range-separator {
  color: #ffffff;
}
.real-wrap .item:nth-child(even) {
  background-color: #1a2f83;
}
.maintance-tree {
  border: none;
  border-radius: 5px;
  // height: 780px;
  // background-image: url("../../../../static/image/kuangbg.png");
  background-size: 100% 100%;
  width: 340px;
  // z-index: 9999;
}
.tree1 {
  height: 350px;
  background-color: #0d115d;
  background-image: url("../../../../static/image/kuangbg.png");
  background-size: 100% 100%;
}
.tree2 {
  height: 350px;
  margin-top: 10px;
  background-color: #0d115d;
  background-image: url("../../../../static/image/kuangbg.png");
  background-size: 100% 100%;
}
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 20px;
}
.warnTable {
  background-image: url("../../../../static/image/kuangbg.png");
  background-size: 100% 100%;
}
// .warnTabless{
//   background-image: url("../../../../static/image/kuangbg.png");
//   background-size: 100% 100%;
// }

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: 100%;
  height: 100%;
}
.table /deep/ .el-table {
  height: 220px;
}
.mmap-wrap {
  height: 560px;
}
// .map4 {
//   // width: 200%;
//   height: 560px;
//   // position: relative;
//   // left: -50%;
//   // top: 4%;
//   // margin-top: 0.2rem;
//   z-index: 999;
// }
/* 设置滚动条的样式 */
::-webkit-scrollbar {
  width: 12px;
}
/* 滚动槽 */
::-webkit-scrollbar-track {
  // -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
  border-radius: 10px;
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  // -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
}
::-webkit-scrollbar-thumb:window-inactive {
  background: rgba(255, 0, 0, 0.4);
}
.animate-up {
  transition: all 1s ease-in-out;
  transform: translateY(-3.2rem);
}
.seamless-warp {
  height: 275px;
  overflow: hidden;
}
.seamless-warp2 {
  height: 275px;
  overflow: hidden;
}
.maintance-wrap
  /deep/
  .el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: #1a2f83;
  color: #ffffff;
}

.maintance-wrap /deep/ .el-tree-node__content:hover {
  background-color: #0a1f73;
  color: #ffffff;
}
.chargeType {
  height: 60px;
  line-height: 60px;
  font-size: 30px;
  color: #fff;
  background: #0d115d;
}
/deep/.el-card__header {
  padding: 10px 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/BMS/maintenanceMonitoring/maintenanceMonitoring.vue